var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-detail-route" }, [
    _vm.isReady
      ? _c(
          "article",
          { staticClass: "project-detail" },
          [
            !_vm.compactHeader
              ? _c("header", { staticClass: "project-detail-header" }, [
                  _c("div", { staticClass: "project-heading-copy" }, [
                    _vm.project.proposalId
                      ? _c("div", { staticClass: "project-source" }, [
                          _vm._v(" " + _vm._s(_vm.$t("projects.from")) + " "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.project.proposalName
                                  ? _vm.project.proposalName
                                  : _vm.$t("projects.project")
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "project-title-row" },
                      [
                        _c("h1", [_vm._v(_vm._s(_vm.project.name))]),
                        _c(
                          "portal-status-pill",
                          {
                            attrs: {
                              background: _vm.project.active
                                ? "var(--v-success_10-base)"
                                : "var(--v-gray_20-base)",
                              color: _vm.project.active
                                ? "var(--v-success-base)"
                                : "var(--portal-muted)"
                            }
                          },
                          [
                            _c("portal-icon", {
                              attrs: {
                                name: _vm.isProjectSuspended(_vm.project)
                                  ? "folder-kanban"
                                  : _vm.project.active
                                  ? "folder-kanban"
                                  : "circle-check",
                                size: 15
                              }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(_vm.projectStatusKey(_vm.project))
                                ) +
                                " "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "project-due" },
                    [
                      _c("portal-icon", {
                        attrs: { name: "calendar-days", size: 17 }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("global.due")))]),
                      _c("strong", [_vm._v(_vm._s(_vm.formattedDueDate))])
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.project.description
              ? _c("section", { staticClass: "project-description" }, [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.project.description) }
                  })
                ])
              : _vm._e(),
            _c("time-and-money", { attrs: { project: _vm.project } }),
            _vm.pendingDeliverables.length || _vm.previousDeliverables.length
              ? _c("section", { staticClass: "project-work" }, [
                  _c("h2", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("projects.client-workflow")))
                  ]),
                  _c("div", { staticClass: "approval-grid" }, [
                    _c(
                      "div",
                      { staticClass: "work-column" },
                      _vm._l(_vm.pendingDeliverables, function(pending) {
                        return _c(
                          "div",
                          { key: pending.statusId, staticClass: "work-group" },
                          [
                            _c("h3", [_vm._v(_vm._s(pending.label))]),
                            _c(
                              "div",
                              { staticClass: "deliverable-grid" },
                              _vm._l(pending.deliverables, function(
                                deliverable
                              ) {
                                return _c("deliverable-card", {
                                  key: deliverable.id,
                                  attrs: {
                                    "status-list": _vm.statusList,
                                    deliverable: deliverable
                                  },
                                  on: {
                                    "open-deliverable": function($event) {
                                      return _vm.openDeliverable(deliverable)
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "work-column" },
                      _vm._l(_vm.previousDeliverables, function(previous) {
                        return _c(
                          "div",
                          { key: previous.statusId, staticClass: "work-group" },
                          [
                            _c("h3", [_vm._v(_vm._s(previous.label))]),
                            _c(
                              "div",
                              { staticClass: "deliverable-grid" },
                              _vm._l(previous.deliverables, function(
                                deliverable
                              ) {
                                return _c("deliverable-card", {
                                  key: deliverable.id,
                                  attrs: {
                                    "status-list": _vm.statusList,
                                    deliverable: deliverable
                                  },
                                  on: {
                                    "open-deliverable": function($event) {
                                      return _vm.openDeliverable(deliverable)
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e(),
            _c(
              "section",
              { staticClass: "project-files" },
              [
                _c("h2", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$t("projects.attachments")))
                ]),
                _c("domain-root", {
                  attrs: {
                    type: "Project",
                    id: _vm.project.id,
                    "show-deleted": _vm.showDeleted,
                    "read-only": !_vm.canEditProject(_vm.project)
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "project-detail-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", size: 32, width: 3, color: "primary" }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }